import HashKeySecurePasswordsIcon from '../resources/student-apps/hashkeysecurepasswords.jpg';
import ShAIdeIcon from '../resources/student-apps/shaide.jpg';
import BookselfIcon from '../resources/student-apps/bookself.jpg';
import TheCloudsIcon from '../resources/student-apps/theclouds.jpg';
import LechatPompomIcon from '../resources/student-apps/lechatpompom.jpg';
import App7AlmIcon from '../resources/student-apps/7alm.jpg';
import ThreadColorIcon from '../resources/student-apps/threadcolor.jpg';
import HaruJournalIcon from '../resources/student-apps/harujournal.jpg';
import KelespikIcon from '../resources/student-apps/kelespik.jpg';
import HookyorganizadordecrochIcon from '../resources/student-apps/hookyorganizadordecroch.jpg';
import HabiIcon from '../resources/student-apps/habi.jpg';
import QouteeIcon from '../resources/student-apps/qoutee.jpg';
import TheAccessibilityProtocolIcon from '../resources/student-apps/theaccessibilityprotocol.jpg';
import GripPoleDanceIcon from '../resources/student-apps/grippoledance.jpg';
import FaltIcon from '../resources/student-apps/falt.jpg';
import MimoDigitalScrapbookIcon from '../resources/student-apps/mimodigitalscrapbook.jpg';
import TrinkitIcon from '../resources/student-apps/trinkit.jpg';
import SpeakChineseTanTanIcon from '../resources/student-apps/speakchinesetantan.jpg';
import TrainPalsIcon from '../resources/student-apps/trainpals.jpg';
import ZniteCarteiradeIngressosIcon from '../resources/student-apps/znitecarteiradeingressos.jpg';
import BulaMovelIcon from '../resources/student-apps/bulamovel.jpg';
import CuritibusQuizIcon from '../resources/student-apps/curitibusquiz.jpg';
import NoPuffIcon from '../resources/student-apps/nopuff.jpg';
import NowOrLaterIcon from '../resources/student-apps/noworlater.jpg';
import PocasIdeiaIcon from '../resources/student-apps/pocasideia.jpg';
import DoyouevenknowmeIcon from '../resources/student-apps/doyouevenknowme.jpg';
import CorporateLadderIcon from '../resources/student-apps/corporateladder.jpg';
import EtiquIcon from '../resources/student-apps/etiqu.jpg';
import ZipItTravelPackingListIcon from '../resources/student-apps/zipittravelpackinglist.jpg';
import LearnKoreanDailywithNamuIcon from '../resources/student-apps/learnkoreandailywithnamu.jpg';
import PitadaIcon from '../resources/student-apps/pitada.jpg';
import KDBusoIcon from '../resources/student-apps/kdbuso.jpg';
import CashyFinanasAutomticasIcon from '../resources/student-apps/cashyfinanasautomticas.jpg';
import LinkdLyricsIcon from '../resources/student-apps/linkdlyrics.jpg';
import SubtractIcon from '../resources/student-apps/subtract.jpg';
import CanrioIcon from '../resources/student-apps/canrio.jpg';
import PluralQuizIcon from '../resources/student-apps/pluralquiz.jpg';
import RabbitLensIcon from '../resources/student-apps/rabbitlens.jpg';
import KoleScoutIcon from '../resources/student-apps/kolescout.jpg';
import NinhoMeuIcon from '../resources/student-apps/ninhomeu.jpg';
import StretCatIcon from '../resources/student-apps/stretcat.jpg';
import TekoScoredeCicloeCorridaIcon from '../resources/student-apps/tekoscoredecicloecorrida.jpg';
import RUNIRunningInjuryGuidebookIcon from '../resources/student-apps/runirunninginjuryguidebook.jpg';
import RunChartsIcon from '../resources/student-apps/runcharts.jpg';
import VECCIIcon from '../resources/student-apps/vecci.jpg';
import artIcon from '../resources/student-apps/art.jpg';
import BoostRunningIcon from '../resources/student-apps/boostrunning.jpg';
import BloopAnotesuasideiasIcon from '../resources/student-apps/bloopanotesuasideias.jpg';
import MeuCrespoIcon from '../resources/student-apps/meucrespo.jpg';
import MeowsicIcon from '../resources/student-apps/meowsic.jpg';
import IbiErosesLinearesIcon from '../resources/student-apps/ibieroseslineares.jpg';
import ContrailIcon from '../resources/student-apps/contrail.jpg';
import DrappyDrawingChallengeIcon from '../resources/student-apps/drappydrawingchallenge.jpg';
import SkyBoundIcon from '../resources/student-apps/skybound.jpg';
import NanInfIcon from '../resources/student-apps/naninf.jpg';
import FlueyMasteranewlanguageIcon from '../resources/student-apps/flueymasteranewlanguage.jpg';

const studentApps = [
  {
    name: `HashKey: Secure Passwords`,
    team: `Gustavo Frehse`,
    link: `https://apps.apple.com/us/app/hashkey-secure-passwords/id6761075213`,
    icon: HashKeySecurePasswordsIcon
  },
  {
    name: `ShAIde`,
    team: `Carla Ferraz de Araujo`,
    link: `https://apps.apple.com/br/app/shaide/id6759338418`,
    icon: ShAIdeIcon
  },
  {
    name: `Book.self`,
    team: `Ana Luísa Luy da Silva`,
    link: `https://apps.apple.com/br/app/book-self-citações-de-livros/id6756063289`,
    icon: BookselfIcon
  },
  {
    name: `The Clouds`,
    team: `Lissa Deguti`,
    link: `https://apps.apple.com/br/app/the-clouds/id6755963655?l=en-GB`,
    icon: TheCloudsIcon
  },
  {
    name: `Le chatô, Pompom`,
    team: `Agratha Cristina`,
    link: `https://apps.apple.com/us/app/le-chat%C3%B4-pompom/id6755973227`,
    icon: LechatPompomIcon
  },
  {
    name: `7-Além`,
    team: `Júlia Bratfisch`,
    link: `https://apps.apple.com/br/app/7-al%C3%A9m/id6749515232 7-Além`,
    icon: App7AlmIcon
  },
  {
    name: `ThreadColor`,
    team: `Ana Julia Molinos`,
    link: `https://apps.apple.com/br/app/thread-color/id6756013888`,
    icon: ThreadColorIcon
  },
  {
    name: `Haru Journal`,
    team: `Angelo Andrioli Netho`,
    link: `https://apps.apple.com/br/app/haru-journal/id6756013352?l=en-GB Haru Journal`,
    icon: HaruJournalIcon
  },
  {
    name: `Kelespik`,
    team: `Everson Galvao`,
    link: `https://apps.apple.com/br/app/kelespik/id6756195494`,
    icon: KelespikIcon
  },
  {
    name: `Hooky : organizador de crochê`,
    team: `Beatriz Perotto Muniz e Mirela Proença`,
    link: `https://apps.apple.com/br/app/hooky-organizador-de-croch%C3%AA/id6760977071`,
    icon: HookyorganizadordecrochIcon
  },
  {
    name: `Habi.`,
    team: `Beatriz Perotto Muniz`,
    link: `https://apps.apple.com/br/app/habi/id6756120708`,
    icon: HabiIcon
  },
  {
    name: `Qoutee`,
    team: `Livia Rosembach Oliveira`,
    link: `https://apps.apple.com/br/app/qoutee/id6753666261?l=en-GB Qoutee`,
    icon: QouteeIcon
  },
  {
    name: `The Accessibility Protocol`,
    team: `Gustavo Frehse`,
    link: `https://apps.apple.com/us/app/the-accessibility-protocol/id6759870720`,
    icon: TheAccessibilityProtocolIcon
  },
  {
    name: `Grip: Pole Dance`,
    team: `Alana Queiroz, Beatriz Muniz, Carla Ferraz, Juliana Segalla e Luiza Gomide`,
    link: `https://apps.apple.com/br/app/grip-pole-dance/id6751820798`,
    icon: GripPoleDanceIcon
  },
  {
    name: `Faltô?`,
    team: `Camili Vitória Jussiani Moreira`,
    link: `https://apps.apple.com/br/app/falt%C3%B4/id6756191812`,
    icon: FaltIcon
  },
  {
    name: `Mimo: Digital Scrapbook`,
    team: `Ana Agner, Carla Ferraz e Celia Vieira`,
    link: `https://apps.apple.com/br/app/mimo-digital-scrapbook/id6760731854`,
    icon: MimoDigitalScrapbookIcon
  },
  {
    name: `Trinkit`,
    team: `Alana Queiroz, Alyss Colin, Luiza Gomide, Pedro Sudario e Yasmin Salamon`,
    link: `https://apps.apple.com/br/app/trinkit/id6748163327`,
    icon: TrinkitIcon
  },
  {
    name: `Speak Chinese - TanTan`,
    team: `Enzo Enrico e Yasmin Salamon`,
    link: `https://apps.apple.com/br/app/speak-chinese-tantan/id6761438972`,
    icon: SpeakChineseTanTanIcon
  },
  {
    name: `TrainPals`,
    team: `Pedro Sudario, Eduardo Bertol, Yasmin Salamon, Alyss Colin e Ruby Rosa`,
    link: `https://apps.apple.com/br/app/trainpals/id6755539277?l=en-GB`,
    icon: TrainPalsIcon
  },
  {
    name: `Zênite: Carteira de Ingressos`,
    team: `Ana Luy, Angelo, Livia Rosembach, Luiz e Vicente`,
    link: `https://apps.apple.com/br/app/zênite-carteira-de-ingressos/id6747890606`,
    icon: ZniteCarteiradeIngressosIcon
  },
  {
    name: `BulaMovel`,
    team: `Juliana Rodrigues`,
    link: `https://apps.apple.com/br/app/bulamovel/id6756028242`,
    icon: BulaMovelIcon
  },
  {
    name: `Curitibus Quiz`,
    team: `Juliana Rodrigues`,
    link: `https://apps.apple.com/br/app/curitibus-quiz/id6753151254`,
    icon: CuritibusQuizIcon
  },
  {
    name: `NoPuff`,
    team: `Livia Barbosa de Oliveira Silva e Tiago Camargo Maciel dos Santos`,
    link: `https://apps.apple.com/app/id6761034273`,
    icon: NoPuffIcon
  },
  {
    name: `NowOrLater`,
    team: `Tiago Camargo Maciel dos Santos`,
    link: `https://apps.apple.com/us/app/noworlater-purchase-partner/id6753960480`,
    icon: NowOrLaterIcon
  },
  {
    name: `PocasIdeia`,
    team: `Tiago Camargo Maciel dos Santos`,
    link: `https://apps.apple.com/us/app/pocasideia/id6753698657`,
    icon: PocasIdeiaIcon
  },
  {
    name: `Do you even know me?`,
    team: `Tiago Camargo Maciel dos Santos`,
    link: `https://apps.apple.com/us/app/do-you-even-know-me/id6753122279`,
    icon: DoyouevenknowmeIcon
  },
  {
    name: `CorporateLadder`,
    team: `Tiago Camargo Maciel dos Santos`,
    link: `https://apps.apple.com/us/app/corporate-ladder/id6749512183`,
    icon: CorporateLadderIcon
  },
  {
    name: `Etiquê`,
    team: `Ana Julia Molinos, Gustavo Hansen, Polliana Santana, Thiago Imai Lima e Tiago Camargo Maciel dos Santos`,
    link: `https://apps.apple.com/br/app/etiquê-scanner-de-etiqueta/id6747895548`,
    icon: EtiquIcon
  },
  {
    name: `Zip It Travel Packing List`,
    team: `Alana Queiroz e Camili Moreira`,
    link: `https://apps.apple.com/br/app/zip-it-travel-packing-list/id6761031657`,
    icon: ZipItTravelPackingListIcon
  },
  {
    name: `Learn Korean Daily with Namu`,
    team: `Gustavo Frehse e Julia Bratfisch`,
    link: `https://apps.apple.com/br/app/learn-korean-daily-with-namu/id6760951897`,
    icon: LearnKoreanDailywithNamuIcon
  },
  {
    name: `Pitada`,
    team: `Livia Barbosa, Matheus Sebastian, Rafael Longhi, Débora Costa e Gustavo Frehse`,
    link: `https://apps.apple.com/br/app/pitada/id6747889796`,
    icon: PitadaIcon
  },
  {
    name: `KDBusão`,
    team: `Rafael Longhi`,
    link: `https://apps.apple.com/br/app/kdbusão/id6756078000`,
    icon: KDBusoIcon
  },
  {
    name: `Cashy: Finanças Automáticas`,
    team: `Débora Costa e Rafael Venetikides`,
    link: `https://apps.apple.com/br/app/cashy-finanças-automáticas/id6761138913`,
    icon: CashyFinanasAutomticasIcon
  },
  {
    name: `LinkdLyrics`,
    team: `Vicente K. Parmigiani`,
    link: `https://apps.apple.com/br/app/linkdlyrics-song-quiz/id6752959275`,
    icon: LinkdLyricsIcon
  },
  {
    name: `Subtract`,
    team: `Thiago Imai`,
    link: `https://apps.apple.com/br/app/subtract/id6753977784?l=en-GB`,
    icon: SubtractIcon
  },
  {
    name: `Canário`,
    team: `Thiago Imai`,
    link: `https://apps.apple.com/us/app/canário/id6758237784`,
    icon: CanrioIcon
  },
  {
    name: `Plural Quiz`,
    team: `Amandha Santos`,
    link: `https://apps.apple.com/br/app/plural-quiz/id6753146286`,
    icon: PluralQuizIcon
  },
  {
    name: `Rabbit Lens`,
    team: `Amandha Santos`,
    link: `https://apps.apple.com/br/app/rabbit-lens-photographer-app/id6761667196?l=en-GB`,
    icon: RabbitLensIcon
  },
  {
    name: `KoleScout`,
    team: `Amandha Santos`,
    link: `https://apps.apple.com/br/app/kolescout/id6753562198`,
    icon: KoleScoutIcon
  },
  {
    name: `Ninho Meu`,
    team: `Amandha, Akira, Jubrat, Thay e Yuske`,
    link: `https://apps.apple.com/br/app/ninho-meu/id6747983634`,
    icon: NinhoMeuIcon
  },
  {
    name: `StretCat`,
    team: `Amandha, Thay e Sebastian`,
    link: `https://apps.apple.com/br/app/stretcat-alongamento-e-pausas/id6760904248`,
    icon: StretCatIcon
  },
  {
    name: `Teko: Score de Ciclo e Corrida`,
    team: `Eduardo Bertol e Juliana Segalla`,
    link: `https://apps.apple.com/br/app/teko-score-de-ciclo-e-corrida/id6761077930`,
    icon: TekoScoredeCicloeCorridaIcon
  },
  {
    name: `RUNI: Running Injury Guidebook`,
    team: `Eduardo Bertol`,
    link: `https://apps.apple.com/br/app/runi-running-injury-guidebook/id6761079297`,
    icon: RUNIRunningInjuryGuidebookIcon
  },
  {
    name: `RunCharts`,
    team: `Eduardo Bertol`,
    link: `https://apps.apple.com/br/app/run-charts/id6755115166`,
    icon: RunChartsIcon
  },
  {
    name: `VECCI`,
    team: `Eduardo Bertol`,
    link: `https://apps.apple.com/br/app/vecci/id6753762025`,
    icon: VECCIIcon
  },
  {
    name: `art?`,
    team: `Eduardo Bertol`,
    link: `https://apps.apple.com/br/app/art/id6749514507`,
    icon: artIcon
  },
  {
    name: `Boost - Running`,
    team: `Carla Araujo, Camili Moreira, Eduardo Bertol, Giovanni Strasser e Mirela Proença`,
    link: `https://apps.apple.com/br/app/boost-running/id6747902328`,
    icon: BoostRunningIcon
  },
  {
    name: `Bloop: Anote suas ideias!`,
    team: `Júlia Bratfisch`,
    link: `https://apps.apple.com/br/app/bloop-anote-suas-ideias/id6753925426`,
    icon: BloopAnotesuasideiasIcon
  },
  {
    name: `Meu Crespo`,
    team: `Thayssa Daniele`,
    link: `https://apps.apple.com/br/app/meu-crespo/id6760083601`,
    icon: MeuCrespoIcon
  },
  {
    name: `Meowsic`,
    team: `André Castilhano e Gabriela Portugal`,
    link: `https://apps.apple.com/br/app/meowsic-faça-sua-track/id6761025426`,
    icon: MeowsicIcon
  },
  {
    name: `Ibi: Erosões Lineares`,
    team: `Gabriela Portugal`,
    link: `https://apps.apple.com/br/app/ibi-erosões-lineares/id6756188502`,
    icon: IbiErosesLinearesIcon
  },
  {
    name: `Contrail`,
    team: `Ana Agner, Camili Moreira, Gabriela Portugal, Pedro Sudário e Tiago Prestes`,
    link: `https://apps.apple.com/br/app/contrail/id6752272792`,
    icon: ContrailIcon
  },
  {
    name: `Drappy: Drawing Challenge`,
    team: `Gustavo Hansen e Livia Rosembach`,
    link: `https://apps.apple.com/br/app/drappy-drawing-challenge/id6761008684`,
    icon: DrappyDrawingChallengeIcon
  },
  {
    name: `SkyBound`,
    team: `Alana Queiroz`,
    link: `https://apps.apple.com/us/app/sky-bound/id6756132160`,
    icon: SkyBoundIcon
  },
  {
    name: `NanInf`,
    team: `Enzo Enrico`,
    link: `https://apps.apple.com/br/app/naninf/id6749869965?l=en-GB`,
    icon: NanInfIcon
  },
  {
    name: `Fluey - Master a new language`,
    team: `Enzo Enrico`,
    link: `https://apps.apple.com/br/app/fluey-master-a-new-language/id6753773457?l=en-GB`,
    icon: FlueyMasteranewlanguageIcon
  },
];

export default studentApps;
